/**
 * Um fluxo como a lista e o topo do builder o mostram: situação, versões,
 * limites do nome. Espelha `flows/domain/flow.py`.
 */
import type { BadgeTone } from '@/core/ui';
import type { Flow, FlowSummary } from './types';

export const NAME_MIN = 2;
export const NAME_MAX = 120;
export const DESCRIPTION_MAX = 500;

export function flowNameProblem(name: string): string | null {
  const n = name.trim().length;
  if (n < NAME_MIN) return `O nome precisa de pelo menos ${NAME_MIN} letras.`;
  if (n > NAME_MAX) return `No máximo ${NAME_MAX} caracteres.`;
  return null;
}

export interface StatusBadge {
  label: string;
  tone: BadgeTone;
}

/**
 * "Publicado · v3" (no ar), "Rascunho" (nunca publicado ou despublicado) e,
 * no ar com mudanças no rascunho, "Alterações não publicadas".
 */
export function flowStatus(flow: Pick<FlowSummary | Flow, 'live_version' | 'dirty'>): StatusBadge[] {
  if (flow.live_version === null) return [{ label: 'Rascunho', tone: 'warning' }];
  const live: StatusBadge = { label: `Publicado · v${flow.live_version}`, tone: 'success' };
  return flow.dirty ? [live, { label: 'Alterações não publicadas', tone: 'neutral' }] : [live];
}

export function isLive(flow: Pick<FlowSummary, 'live_version'>): boolean {
  return flow.live_version !== null;
}

const dateTime = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'America/Sao_Paulo',
});

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTime.format(d).replace(',', '');
}

export function sessionsLabel(n: number): string {
  if (n === 0) return 'Nenhuma conversa';
  return n === 1 ? '1 conversa' : `${n.toLocaleString('pt-BR')} conversas`;
}
